module.exports = __webpack_public_path__ + "static/media/ico_tint_light_sel.07d981dd.svg";